import React from 'react';
import { SkeletonBlock } from '@one-thd/sui-atomic-components';

export function TileStatusPlaceholder() {
  return <SkeletonBlock aspect="wide" height={8} width={32} />;
}
